/**
 * UI Input Type Constants
 * Defines all available field types in the UIC Form system
 */

export enum UIInputType {
  Text = 'text',
  Number = 'number',
  Email = 'email',
  Password = 'password',
  Textarea = 'textarea',
  Select = 'select',
  Checkbox = 'checkbox',
  Radio = 'radio',
  Date = 'date',
  DateTime = 'datetime',
  Time = 'time',
  File = 'file',
  Image = 'image',
  Document = 'document',
  RichText = 'richtext',
  Toggle = 'toggle',
  SelectNAdd = 'selectnadd',
  SearchNAdd = 'searchnadd',
  ExtAddressDetail = 'extaddressdetail',
  ExtContactDetail = 'extcontactdetail',
  ExtDocumentUpload = 'extdocumentupload',
  BillingDeliveryAddress = 'billingdeliveryaddress',
}

/**
 * Human-readable labels for each field type
 */
export const FIELD_TYPE_LABELS: Record<string, string> = {
  [UIInputType.Text]: 'Text Input',
  [UIInputType.Number]: 'Number Input',
  [UIInputType.Email]: 'Email Input',
  [UIInputType.Password]: 'Password Input',
  [UIInputType.Textarea]: 'Text Area',
  [UIInputType.Select]: 'Dropdown Select',
  [UIInputType.Checkbox]: 'Checkbox',
  [UIInputType.Radio]: 'Radio Button',
  [UIInputType.Date]: 'Date Picker',
  [UIInputType.DateTime]: 'Date Time Picker',
  [UIInputType.Time]: 'Time Picker',
  [UIInputType.File]: 'File Upload',
  [UIInputType.Image]: 'Image Upload',
  [UIInputType.Document]: 'Document Upload',
  [UIInputType.RichText]: 'Rich Text Editor',
  [UIInputType.Toggle]: 'Toggle Switch',
  [UIInputType.SelectNAdd]: 'Select with Add New',
  [UIInputType.SearchNAdd]: 'Searchable with Add New',
  [UIInputType.ExtAddressDetail]: 'Extended Address Detail',
  [UIInputType.ExtContactDetail]: 'Extended Contact Detail',
  [UIInputType.ExtDocumentUpload]: 'Extended Document Upload',
  [UIInputType.BillingDeliveryAddress]: 'Billing/Delivery Address',
};

/**
 * Field types that require API data
 */
export const DATA_DRIVEN_FIELD_TYPES = [
  UIInputType.Select,
  UIInputType.SelectNAdd,
  UIInputType.SearchNAdd,
];

/**
 * Field types for file uploads
 */
export const FILE_UPLOAD_FIELD_TYPES = [
  UIInputType.File,
  UIInputType.Image,
  UIInputType.Document,
  UIInputType.ExtDocumentUpload,
];

/**
 * Field types that support searchability
 */
export const SEARCHABLE_FIELD_TYPES = [
  UIInputType.Select,
  UIInputType.SearchNAdd,
];

/**
 * Complex/composite field types
 */
export const COMPLEX_FIELD_TYPES = [
  UIInputType.ExtAddressDetail,
  UIInputType.ExtContactDetail,
  UIInputType.ExtDocumentUpload,
  UIInputType.BillingDeliveryAddress,
];
